import { FILTERS_MODAL } from 'components/Scroller/constants';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { DEPARTURE_PORT } from 'contexts/CruiseSearchContext/constants';
import { useContext, useEffect, useRef, useState } from 'react';
import useAnimations from './animations';

import Header from 'components/FiltersModal/Header';
import { Constrain, Divider, SectionTitle } from 'components/FiltersModal/components';
import { FILTERS_SEARCH_BAR } from '../../constants';
import FilterSearchBar from '../FilterSearchBar';

import classnames from 'classnames';

import { getBrandUISettings } from 'lib/utilities/Brands';
import PropTypes from 'prop-types';
import { useFeatureFlags } from '../../../../hooks/LaunchDarkly/useFeatureFlags';
import { Button, ButtonWrap, PortOptions, Section } from './components';

export const PORT_OPTIONS = {
	key: DEPARTURE_PORT,
	label: 'All departure ports',
	options: [],
};

/**
 * DestinationPort
 *
 * The DestinationPort filter component
 * listens to/sets the departurePort param of the search query
 */

const DeparturePort = ({ setModalHeight }) => {
	const { tweenIn } = useAnimations();
	const {
		filterOptionsDictionary,
		searchSelecting,
		addToSearchSelectingFilter,
		removeFromSearchSelectingFilter,
		resetSearchSelectingFilter,
		globalization,
		fetchAndUpdateFacetOptions,
		facetOptions,
		brand,
	} = useContext(CruiseSearchContext);
	const { showDeparturePortsRegions } = useFeatureFlags();
	const { uiSettings } = getBrandUISettings(brand);
	const [optionsLoaded, setOptionsLoaded] = useState(filterOptionsDictionary?.departurePort);

	const { filtersDictionary } = globalization?.dictionaries || {};
	const { navDeparturePort, inputDeparturePortSearchPlaceholder } = filtersDictionary;

	const varationRule = showDeparturePortsRegions;

	const departurePortGroups = filterOptionsDictionary?.departurePort?.groups;

	if (optionsLoaded) {
		if (varationRule.length > 0) {
			const variationOrderPort = departurePortGroups
				.filter((element) => {
					return varationRule.find((op) => element.code == op);
				})
				.sort((a, b) => varationRule.indexOf(a.code) - varationRule.indexOf(b.code));
			PORT_OPTIONS.options =
				variationOrderPort?.map((group) => ({
					...group,
					options: group.options.sort((a, b) => (a.label > b.label ? 1 : -1)),
				})) || [];
		} else {
			PORT_OPTIONS.options =
				departurePortGroups?.map((group) => ({
					...group,
					options: group.options.sort((a, b) => (a.label > b.label ? 1 : -1)),
				})) || [];
		}
	}

	useEffect(() => {
		setModalHeight(750);
	});

	useEffect(() => {
		if (filterOptionsDictionary?.departurePort) {
			setOptionsLoaded(true);
		}
	}, [filterOptionsDictionary.departurePort, optionsLoaded]);

	const addPortToDeparture = (port) => {
		addToSearchSelectingFilter('departurePort', port, fetchAndUpdateFacetOptions);
	};

	const updatePorts = (code) => {
		if (searchSelecting?.[PORT_OPTIONS.key]?.includes(code)) {
			removeFromSearchSelectingFilter(PORT_OPTIONS.key, code, fetchAndUpdateFacetOptions);
		} else {
			addToSearchSelectingFilter(PORT_OPTIONS.key, code, fetchAndUpdateFacetOptions);

			// TODO: Implement LaunchDarkly feature flag for Miami and Fort Lauderdale
			if (code === 'MIA' && facetOptions?.departurePort?.FLL?.count > 0) {
				addPortToDeparture('FLL');
			}
			if (code === 'FLL' && facetOptions?.departurePort?.MIA?.count > 0) {
				addPortToDeparture('MIA');
			}
		}
	};

	const optionsRef = useRef([]);
	const sectionTitlesRef = useRef([]);

	const resetFilterOptions = () => {
		resetSearchSelectingFilter(DEPARTURE_PORT, fetchAndUpdateFacetOptions);
	};

	useEffect(() => {
		if (optionsLoaded) {
			tweenIn(sectionTitlesRef.current);
			tweenIn(optionsRef.current);
		}
	}, [tweenIn]);

	return (
		<div>
			<Header title={navDeparturePort} onReset={() => resetFilterOptions()} />
			<Constrain>
				<FilterSearchBar
					searchesAllowing={[PORT_OPTIONS.key]}
					scrollerId={FILTERS_MODAL}
					placeholder={inputDeparturePortSearchPlaceholder}
					container={FILTERS_SEARCH_BAR.DEPARTURE_PORT}
				/>
				{PORT_OPTIONS?.options.map((location, i) => {
					return (
						<>
							<Section key={location.code}>
								<SectionTitle ref={(el) => (sectionTitlesRef.current[i] = el)} title={location.label} />
								<PortOptions ref={(el) => (optionsRef.current[i] = el)} gap={uiSettings.filtersModal.filtersGrid.gap}>
									{location?.options?.map((option, i) => {
										const disabled = !facetOptions[DEPARTURE_PORT]?.[option.code]?.count > 0;
										const selected = searchSelecting[PORT_OPTIONS.key]?.includes(option.code) || false;
										return (
											<ButtonWrap
												key={`${option.label}-${i}`}
												className={classnames({
													disabled: selected ? false : disabled,
												})}
											>
												<Button id={`departure-port-label-${option.code}`} showX={false} onClick={() => updatePorts(option.code)} selected={selected}>
													{option.label || option.code}
												</Button>
											</ButtonWrap>
										);
									})}
								</PortOptions>
							</Section>
							{PORT_OPTIONS?.options.length - 1 !== i ? <Divider /> : null}
						</>
					);
				})}
			</Constrain>
		</div>
	);
};

DeparturePort.propTypes = {
	setModalHeight: PropTypes.func,
};

export default DeparturePort;
